import { render, staticRenderFns } from "./PassengerImportsTable.vue?vue&type=template&id=de82d256"
import script from "./PassengerImportsTable.vue?vue&type=script&lang=ts"
export * from "./PassengerImportsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports